// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { SalesState } from "@/types/sales";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Sales } from "@/models/sales";

const state: SalesState = {
  single: new Sales(),
  pagination: new Pagination(),
};

export const sales: Module<SalesState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
